import type { SubPractices } from "../config.types";

import {
  immigrationBookLssScreens,
  immigrationEligibleForLssScreens,
  intakeConfirmationScreens,
} from "./common-immigration";

export const immigrationCitizenship: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async ({ answers }) => {
        const { serviceType } = answers;

        if (serviceType === "I’m a green card holder") {
          return "married-to-citizen";
        }

        if (serviceType === "Something else") {
          return "out-of-scope";
        }

        return "deportation-or-removal";
      },
    },
    "married-to-citizen": {
      next: async () => "green-card-duration",
    },
    "green-card-duration": {
      next: async ({ answers }) => {
        const { marriedToCitizen, greenCardDuration } = answers;

        let isInScope = greenCardDuration === "4.5+ years";
        if (marriedToCitizen === "Yes") {
          isInScope = ["2-4.5 years", "4.5+ years"].includes(
            greenCardDuration!,
          );
        }
        return isInScope ? "deportation-or-removal" : "out-of-scope";
      },
    },
    "applicant-type": {
      next: async () => "case-urgency",
    },
    "case-urgency": {
      next: async () => "more-info",
    },

    ...immigrationEligibleForLssScreens,

    "funding-source": {
      next: async () => "beneficiary-region",
    },
    "beneficiary-region": {
      next: async () => "more-info",
    },

    ...intakeConfirmationScreens,
    ...immigrationBookLssScreens,

    "out-of-scope": {
      next: async () => undefined,
    },
  },
};
